import React from 'react'

const SuccessCoachPage = () => {
  return (
    <div>SuccessCoachPage</div>
  )
}

export default SuccessCoachPage